import React, { useState, useEffect, useId } from 'react';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const StarRating = ({ initialRating = 0, onRatingChange, lock, styles = {} }) => {
    const [selectedRating, setSelectedRating] = useState(initialRating);
    const [hoveredRating, setHoveredRating] = useState(0);
    const starWidth = styles?.starWidth || 16;
    const starHeight = styles?.starHeight || 16;
    const starBgColor = styles?.starBgColor || 'white'
    // useId generates stable IDs that match between SSR and client hydration
    const uniqueId = useId();

    useEffect(() => {
        setSelectedRating(initialRating);
    }, [initialRating]);

    const handleMouseEnter = (index) => {
        if (lock) return;
        setHoveredRating(index + 1);
    };

    const handleMouseLeave = () => {
        if (lock) return;
        setHoveredRating(0);
    };

    const handleClick = (index) => {
        if (lock) return;
        const newRating = index + 1;
        setSelectedRating(newRating);

        if (onRatingChange) {
            onRatingChange(newRating);
        }
    };

    const renderStars = () => {
        return Array.from({ length: 5 }, (_, index) => {
            const isHovered = index < hoveredRating;
            let fillPercentage = 0;
            if (index < selectedRating) {
                fillPercentage = Math.min(Math.max(selectedRating - index, 0), 1) * 100;
            }

            if (hoveredRating !== 0 && hoveredRating <= index) {
                fillPercentage = 0;
            }

            return (
                <Box
                    as={lock ? "div" : "button"}
                    type={!lock ? "button" : undefined}
                    key={index}
                    onMouseEnter={!lock ? () => handleMouseEnter(index) : undefined}
                    onMouseLeave={!lock ? handleMouseLeave : undefined}
                    onClick={!lock ? () => handleClick(index) : undefined}
                    cursor={'pointer'}
                    display={'inline-block'}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={starWidth}
                        height={starHeight}
                        viewBox="0 0 16 16"
                    >
                        <defs>
                            <linearGradient id={`${uniqueId}-${index}`}>
                                <stop offset={`${fillPercentage}%`} stopColor={isHovered ? 'black' : 'black'} />
                                <stop offset={`${fillPercentage}%`} stopColor={isHovered ? 'black' : starBgColor} />
                            </linearGradient>
                        </defs>
                        <g clipPath="url(#a)">
                            <path
                                fill={`url(#${uniqueId}-${index})`}
                                stroke="gray"
                                strokeLinecap="square"
                                strokeWidth=".667"
                                d="m8.334 1.334 2.167 4.388 4.844.708-3.505 3.414.826 4.823-4.332-2.278-4.332 2.278.827-4.823-3.505-3.413 4.844-.709z"
                                clipRule="evenodd"
                            />
                        </g>
                        <defs>
                            <clipPath id="a">
                                <path fill={starBgColor} d="M.334 0h16v16h-16z" />
                            </clipPath>
                        </defs>
                    </svg>
                </Box>
            );
        });
    };

    return <div>{renderStars()}</div>;
};

StarRating.propTypes = {
    initialRating: PropTypes.number,
    onRatingChange: PropTypes.func,
    lock: PropTypes.bool,
    styles: PropTypes.object
};

export default StarRating;
